module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Edit banner":"Banner bearbeiten","Banner format hint":"Der Banner wird im Format 16:9 zugeschnitten. Verschiebe/zoome den Ausschnitt und übernimm ihn. Das Originalbild bleibt erhalten.","Reset":"Zurücksetzen","Apply":"Übernehmen","Cancel":"Abbrechen"}}')
  delete Component.options._Ctor
}
